// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2VvC-","left":"StickyBox_left__8slfI","right":"StickyBox_right__1P_cv"};